export const RUNNING_INDICATOR_SIZE = 14;
